import Script from 'next/script';

const ZendeskScript: React.FC = () => (
  <Script
    id="ze-snippet"
    strategy="lazyOnload"
    src="https://static.zdassets.com/ekr/snippet.js?key=34803478-4352-4be8-a5fb-f9c7033da23f"
  />
);

export default ZendeskScript;
